import React from 'react';

export const CatServPendientes = (props) => {
	const {Categorias, ServiciosPendientes, CategoriasPendientes} = props;
	return (
		<div className='Body-CatServActivos'>
			<div className='servicios-CatServActivos serviciosActivas-CatServActivos'>
				<div className='title-CatServActivos title-1'>
					<h2>Servicios Pendientes</h2>
					<div className='separador' />
				</div>
				{ServiciosPendientes.length > 0 &&
					CategoriasPendientes.map((categoria) => (
						<div className='servicio-CatServActivos servicioActivo-CatServActivos'>
							<div className='title-CatServActivos title-2 title-servicios-CatServActivos'>
								<h3>Servicios de {categoria.categoria_id.nombre}</h3>
							</div>
							<div className='separador' />
							<div className='lista-servicio-CatServActivos '>
								{ServiciosPendientes.map(
									(servicio) =>
										servicio.servicio_id.categoria_id.id ===
											categoria.categoria_id.id && (
											<div className='card-servicio-CatServActivos'>
												<div className='title-CatServActivos title-3 title-servicio-CatServActivos'>
													<div className='centrador'>
														{servicio.servicio_id.nombre +
															' - ' +
															categoria.categoria_id.nombre}
													</div>
													<div className='servicio-aceptado'>
														<div>Pendiente</div>
													</div>
												</div>
												<div className='separador' />
												<div className='descripcion-servicio'>
													{servicio.descripcion}
												</div>
												<div className='descripcion-servicio'>
													<b>Duracion: </b>
													{servicio.horasMin} minutos
												</div>
												<div className='descripcion-servicio'>
													<b>Precio: </b>
													{servicio.precioMin} €
												</div>
												<div className='tipes-servicios-descripcion-servicio'>
													{servicio.domicilio && (
														<div className='centradorLeft'>
															<div className='domicilio-servicioOfrecido-perfilAgencia-nuevo'>
																Domicilio
															</div>
														</div>
													)}
													{servicio.shareCare && (
														<div className='centradorLeft'>
															<div className='shareCare-servicioOfrecido-perfilAgencia-nuevo'>
																ShareCare
															</div>
														</div>
													)}
												</div>
											</div>
										)
								)}
							</div>
						</div>
					))}
			</div>
		</div>
	);
};
